import React from 'react';

const DEFAULT_STATE = {
  cloudFlareBaseUrl: null,
  initialUrlParamKeys: {},
};

export const AppContext = React.createContext(DEFAULT_STATE);

const Provider = (props) => {
  return (
    <AppContext.Provider value={{ DEFAULT_STATE }}>
      {props.children}
    </AppContext.Provider>
  );
};
// eslint-disable-next-line react/display-name
export default ({ element }) => <Provider>{element}</Provider>;
